import {createContext, use} from 'react'
import type {LayoutContextValue} from './types'

export const LayoutContext = createContext<LayoutContextValue | null>(null)

export function useLayoutContext(): LayoutContextValue {
  const context = use(LayoutContext)
  if (!context) {
    throw new Error('useLayoutContext must be used within a Layout component')
  }
  return context
}
